import { render } from "./zdspindex.vue?vue&type=template&id=40596550&scoped=true"
import script from "./zdspindex.vue?vue&type=script&lang=js"
export * from "./zdspindex.vue?vue&type=script&lang=js"

import "./zdspindex.vue?vue&type=style&index=0&id=40596550&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40596550"]])

export default __exports__